var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inputType === "checkbox"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.handleInputValue,
            expression: "handleInputValue",
          },
        ],
        ref: "inputElement",
        staticClass: "inputItem",
        class: { disabled: _vm.disabled },
        attrs: {
          placeholder: _vm.placeholderValue,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          autocomplete: _vm.autocompleteValue,
          type: "checkbox",
        },
        domProps: {
          checked: Array.isArray(_vm.handleInputValue)
            ? _vm._i(_vm.handleInputValue, null) > -1
            : _vm.handleInputValue,
        },
        on: {
          input: _vm.onInput,
          blur: _vm.onBlur,
          focus: _vm.onFocus,
          change: function ($event) {
            var $$a = _vm.handleInputValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.handleInputValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.handleInputValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.handleInputValue = $$c
            }
          },
        },
      })
    : _vm.inputType === "radio"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.handleInputValue,
            expression: "handleInputValue",
          },
        ],
        ref: "inputElement",
        staticClass: "inputItem",
        class: { disabled: _vm.disabled },
        attrs: {
          placeholder: _vm.placeholderValue,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          autocomplete: _vm.autocompleteValue,
          type: "radio",
        },
        domProps: { checked: _vm._q(_vm.handleInputValue, null) },
        on: {
          input: _vm.onInput,
          blur: _vm.onBlur,
          focus: _vm.onFocus,
          change: function ($event) {
            _vm.handleInputValue = null
          },
        },
      })
    : _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.handleInputValue,
            expression: "handleInputValue",
          },
        ],
        ref: "inputElement",
        staticClass: "inputItem",
        class: { disabled: _vm.disabled },
        attrs: {
          placeholder: _vm.placeholderValue,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          autocomplete: _vm.autocompleteValue,
          type: _vm.inputType,
        },
        domProps: { value: _vm.handleInputValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.handleInputValue = $event.target.value
            },
            _vm.onInput,
          ],
          blur: _vm.onBlur,
          focus: _vm.onFocus,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }